module.exports = __webpack_public_path__ + "img/zil.b45d464a.png";